<template>
  <!--<div id="app">-->
    <!--<div id="nav">-->
      <!--<router-link to="/">Home</router-link> |-->
      <!--<router-link to="/about">About</router-link>-->
    <!--</div>-->
    <!--<router-view/>-->
  <!--</div>-->
  <div id="wrapper" v-if="!$route.meta.loginLayout">
    <Navigation/>
    <div id="page-wrapper" class="gray-bg">
      <Header />
      <router-view/>
      <Footer/>
      <div class="portal-toast-column" v-if="isPlatformRole">
        <LiveOrderToast/>
        <MenuAvailabilityToast/>
      </div>
    </div>
  </div>
  <div v-else-if="$route.meta.loginLayout">
    <router-view/>
  </div>
</template>

<script>
    /* eslint-disable */

    import Navigation from '@/components/layout_components/Navigation'
    import Header from '@/components/layout_components/Header'
    import Footer from '@/components/layout_components/Footer'
    import LiveOrderToast from '@/components/orders/live/LiveOrderToast'
    import MenuAvailabilityToast from '@/components/menu_alerts/MenuAvailabilityToast'
    import { unlock } from '@/services/notificationSound'
    import { unlock as unlockMenuSound } from '@/services/menuAlertSound'
    export default {
        name: 'App',
        data() {
            return {
                messagingObject: null
            }
        },
        components: {
            Navigation,
            Header,
            Footer,
            LiveOrderToast,
            MenuAvailabilityToast
        },
        computed: {
            isPlatformRole: function () {
                const roles = this.$store.state.user.userRolesById;
                if (!roles || !roles.length) return false;
                const role = roles[0].role;
                return role === 'ROLE_ADMIN' || role === 'ROLE_AGENT' || role === 'ROLE_MANAGER';
            }
        },
        created: function () {
            this.$http.interceptors.request.use((request) => {
                const token = 'Bearer '+ this.$store.getters.accessToken;
                if(request.headers.Authorization !== undefined && request.headers.Authorization !== token) {
                  request.headers.Authorization = token;
                }
                Pace.start();
                return request;
            }, (error) => {
                return Promise.reject(error);
            });
            this.$http.interceptors.response.use((response) => {
                Pace.stop();
                return response;
            }, (error) => {
                Pace.stop();
                const status = (error && error.response) ? error.response.status : null;
                const config = error ? error.config : null;

                if(status === 401 /*&& !originalRequest._retry*/) {
                  console.log("In Error In 401 Interceptor");
                  return this.updateRefreshToken(config);
                }else {
                  return Promise.reject(error);
                }
            });
        },
        mounted: function () {
            document.title = "Delivery Monsters - Portal";
            if (this.$store.state.user.userRolesById !== undefined) {
                // The action owns the role logic now (branches still need isPortalEnabled,
                // and the server answers 403 for roles that get no realtime), so every
                // logged-in user can ask.
                this.$store.dispatch('validateUserAndCreateWebsocketConnection');

                if (this.isPlatformRole) {
                    // Seed the sidebar badge once. After this the count is only refetched
                    // when an Ably event says it changed — there is no polling.
                    this.$store.dispatch('liveOrders/refreshCounts');
                    // Arm the alert sound on the first gesture after a reload.
                    document.addEventListener('click', unlock, {once: true});
                    document.addEventListener('click', unlockMenuSound, {once: true});
                }
            }
        },
        beforeDestroy: function () {
            document.removeEventListener('click', unlock);
            document.removeEventListener('click', unlockMenuSound);
        }
    }
</script>


<style >
  /* One fixed column owns the toast position so the order and menu stacks flow under each
     other instead of overlapping. The column itself is click-through, otherwise an empty
     320px strip would swallow clicks meant for the page header; only the cards take them. */
  .portal-toast-column {
    position: fixed;
    top: 70px;
    right: 20px;
    width: 320px;
    z-index: 2050;
    pointer-events: none;
  }
  .portal-toast-column .live-toast,
  .portal-toast-column .menu-toast {
    pointer-events: auto;
  }
  .select2-container{
    z-index: 10000 !important;
  }
  .dataTables_processing{
    position: absolute;
    right: 50%;
    top: 50%;
    margin-top: 10px;
  }
  /*.table-responsive{*/
    /*overflow-x: initial !important;*/
  /*}*/

  @media only screen and (min-width: 1281px) {
    .table-responsive {
      overflow-x: initial !important;
    }
  }
  .form-control {
    height: 40px !important;
  }
</style>
